export abstract class Dictionary {
  private static bulgarianPhrases = {
    1: "Начало",
    2: "За нас",
    3: "Услуги",
    4: "Контакти",
		5: "Работно време: Понеделник-Петък 08:30-18:00 ч.",
		6: "Адрес: България, гр. Русе, площад Св. Троица №2, етаж 1",
		7: "Телефон",
		8: "Имейл",
    9: "Свържете се с нас",
    10: "Имате въпроси? Попълнете формата за контакт и с радост ще Ви отговорим или насрочете 30 минутна онлайн среща в Google Meet от ",
    11: "Тема",
    12: "Име",
    13: "Фамилия",
    14: "Съобщение",
    15: "Изпрати",
    16: "Иван",
    17: "Петров",
    18: "example@gmail.com",
    19: "Мариян Маринов",
    20: "Управител, Старши софтуерен инженер",
    21: "Снимка",
    22: "<p>Мариян е Senior full-stack software developer с над 10г. професионален опит в разработката и поддръжката на софтуер. Опитът му в back-end програмирането е предимно с .NET екосистемата - пише на C# и Visual Basic, но също така има добри познания и в NodeJS като алтернатива. Добре запознат е с Entity Framework Core и Dapper като ORM решения. През годините е работил с голям набор от релационни и нерелационни бази данни като MSSQL, MySQL, PostgreSQL, Cassandra.</p> <p>За front-end разработка има опит в използването на React, Angular и Aurelia frameworks, както на JavaScript така и на TypeScript, jQuery, CSS, SCSS, SASS, Bootstrap, Prime React, Angular Materials.</p> <p>Що се отнася до клауд, инфраструктура и деплоймент - силите на Мариян са в Amazon Web Services, Azure, Docker и Terraform.</p>",
    23: "Жоро Паспалев",
    24: "Софтуерен инженер",
    25: "<p>Жоро е full-stack software developer с 3 години професионален опит. Технологичният му стек включва C#, JavaScript и TypeScripт, Entity Framework Core, Dapper, SQL, MySQL, MSSQL Server, MySQL, PostgreSQL, Angular framework, Bootstrap, CSS, SCSS, SASS, Angular Material, Amazon Web Services, Docker, Terraform.</p>",
    26: "Даниел Дианов",
    27: "Младши софтуерен инженер",
    28: "<p>Даниел е full-stack software developer с 1 година професионален опит. Технологичният му стек включва C#, Visual Basic, JavaScript, TypeScript, Entity Framework Core, Dapper, SQL, MySQL, MSSQL Server, MariaDB, React, Aurelia, Angular, Bootstrap, CSS, SCSS, SASS, Docker.</p>",
    29: "Екип",
    30: "тук",
    31: ", за да обсъдим всичко, което Ви интересува.",
    32: "Sharp IT - Начало",
    33: "Sharp IT - За нас",
    34: "Sharp IT - Услуги",
    35: "Sharp IT - Контакти",
    36: "Sharp IT - Свободни позици",
    37: "Sharp IT - Страницата не е открита",
    38: "Свободни позиции",
    39: "Добре дошли в Sharp IT, където иновациите срещат функционалността.",
    40: "В Sharp IT ние създаваме повече от просто уебсайтове – ние създаваме мощни, скалируеми и удобни за потребителя уеб приложения, които подпомагат растежа на бизнеса. Нашият експертен екип от разработчици, дизайнери и стратези работят съвместно, за да вдъхнат живот на Вашите идеи с технологии, които отговарят на Вашите цели.",
    41: "Индустрии, които обслужваме",
    42: "Пътуване и хотелиерство",
    43: "Здравеопазване и медицина",
    44: "Търговия и електронна търговия",
    45: "Образование и електронно обучение",
    46: "Производство и логистика",
    47: "Недвижими имоти",
    48: "Процес на работа",
    49: "Планиране",
    50: "Започваме с разбиране на вашите бизнес предизвикателства и цели, като ви помагаме да определите обхвата на проекта, сроковете и ресурсите.",
    51: "Изработване на дизайн и прототип",
    52: "Нашият дизайнерски екип създава прототипи, за да визуализира потребителското изживяване и да получи Вашите отзиви, преди да започне разработката.",
    53: "Разработка и тестване",
    54: "Ние вдъхваме живот на проекта, като пишем чист, скалируем код и провеждаме задълбочено тестване, за да гарантираме, че всичко работи според очакванията.",
    55: "Деплойване и поддръжка",
    56: "След като вашият проект е готов, ние го качваме на реална среда и осигуряваме постоянна поддръжка, за да поддържате нещата гладки.",
    57: "Експертиза, на която можете да се доверите",
    58: "Ние имаме дългогодишен опит в индустрията за разработка на софтуер и използваме най-новите технологии и най-добри практики, за да предоставим висококачествени решения, които работят.",
    59: "Фокусиран върху клиента подход",
    60: "Ние отделяме време, за да разберем вашите бизнес цели и да създадем персонализирани решения, които водят до осезаеми резултати. Вашият успех е наш успех.",
    61: "Гъвкав и съвместен процес",
    62: "Нашата методология за гъвкаво разработване гарантира, че проектите се доставят навреме и в рамките на бюджета. Ние ценим сътрудничеството, прозрачността и ясната комуникация на всеки етап.",
    63: "Услуга от край до край",
    64: "От първоначалната консултация до поддръжката след реализиране на проекта, ние предоставяме цялостни услуги, за да гарантираме успеха на вашия проект във всяка фаза от жизнения цикъл на разработка.",
    65: "Съвременни технологии",
    66: "Нашият екип владее широк набор от езици за програмиране, инструменти за разработка, включително C#, JavaScript, TypeScript, React, Angular и др.",
    67: "Защо да изберете нас?",
    68: "Услуги",
    69: "Научете повече",
    70: "Разработка на уеб приложения",
    71: "Изграждане на динамични приложения, които поддържат вашите бизнес процеси, интегрират се със системи на трети страни, с възможност за разрастване според нуждите на бизнеса.",
    72: "Решения за електронна търговия",
    73: "Разработка на платформа за електронна търговия от край до край, от продуктови каталози до интеграция на сигурни платежни системи и безпроблемно изживяване на клиентите.",
    74: "Системи за управление на съдържание",
    75: "Здрави, гъвкави CMS платформи, които ви позволяват да управлявате съдържанието лесно и ефективно без техническа експертиза.",
    76: "UX/UI дизайн",
    77: "Интуитивен и визуално привлекателен дизайн, който дава приоритет на потребителското изживяване. Нашите дизайни гарантират, че вашият уебсайт или приложение са функционални и естетически привлекателни.",
    78: "Поддръжка на уеб приложения",
    79: "Текуща поддръжка, за да се гарантира, че вашият уебсайт остава актуален, защитен и оптимизиран за ефективност.",
    80: "Услуги",
    81: "Ние сме бързо развиваща се компания със седалище в Русе, България, която е специализирана в разработка на уеб решения за различни нужди от реалния живот.",
    82: "В Sharp IT нашата най-голяма сила е в нашите хора.",
    83: "Нашият екип се състои от висококвалифицирани професионалисти, които са запалени по използването на технологии за създаване на въздействащи решения за бизнес нужди.",
    84: "Ние не сме просто разработчици; ние решаваме проблеми, процъфтяваме при наличието на предизвикателства и сме посветени на постигането на успех за нашите клиенти.",
    85: "Ние сме водени от ангажимента да доставяме повече от просто продукти.",
    86: "Нашият уютен офис насърчава сътрудничеството и креативността, осигурявайки удобно пространство за нашия талантлив екип от разработчици и технологични ентусиасти.",
    87: "Предлагаме топла и приятелска среда и даваме приоритет на баланса между работата и личния живот.",
    88: "Ние в Sharp IT вярваме в изграждането на партньорства, които дават възможност на бизнеса да разгърне пълния си потенциал.",
    89: "Нашият подход се основава на прозрачност, сътрудничество и задълбочено разбиране на тенденциите в индустрията.",
    90: "Нашият екип си сътрудничи тясно с клиентите, за да разбере техните нужди, предоставяйки ценни решения, които автоматизират процесите, повишават производителността и стимулират непрекъснато подобрение.",
    91: "Следвайки тенденциите, ние помагаме на бизнеса не само да се адаптира към промяната, но и да процъфтява в непрекъснато развиваща се цифрова среда.",
    92: "В Sharp IT вашият растеж е нашата мисия и ние сме посветени да бъдем ваш доверен партньор на всяка стъпка от пътя.",
    93: "Проекти, по които сме работили",
    94: "Нашият екип има богат опит в различни индустрии, включително:",
    95: "Финанси и одит: Създаване на сигурни и ефективни системи, които гарантират съответствие и автоматизират сложни финансови работни процеси.",
    96: "Управление на пътища/настилки: Разработване на интелигентни решения за мониторинг на инфраструктурата и прогнозна поддръжка.",
    97: "Управление на събития: Подобряване на координацията и планирането на събития с иновативни инструменти за автоматизация.",
    98: "Техническа експертиза",
    99: "Ние сме технически гъвкави и адаптивни. Имаме богат опит и познания при работа с:",
    100: "Разнообразни архитектури: От монолитни системи до микросървисни архитектури, ние проектираме решения, които са скалируеми, стабилни и лесни за поддръжка.",
    101: "Облачни платформи: Използваме AWS (S3, Route53, Lambdas, Batches, Step Functions и др.), както и Azure за сигурни и скалируеми облачни решения.",
    102: "CI/CD Excellence: Имплементираме добре структурирани решения за автоматизиран деплоймент с помощта на GitHub Actions и Terraform, осигуряващи плавни и ефективни цикли на доставка.",
    103: "Нашият технологичен стек включва:",
    104: "Позволени типове файлове",
    105: "Максимална големина на файл",
    106: "Неподдържан формат на файл.",
    107: "Неподдържана големина на файл.",
    108: "Файлът е твърде голям.",
    109: "Файлове с големина над 5 MB не могат да бъдат изпратени.",
    110: "Неподдържан формат на файл.",
    111: "Форматът на файла не се поддържа. Поддържани формати са PDF, DOC и DOCX.",
    112: "Изпращане ",
    113: "Липсва прикачен файл",
    114: "Необходимо е да прикачите CV, за да продължите.",
    115: "Успех",
    116: "Кандидатурата е изпратена успешно.",
    117: "Възникна непредвидена грешка.",
    118: "Моля, използвайте формата за контакт, за да докладвате за този проблем.",
    119: "GitHub профил:",
    120: "LinkedIn профил:",
    121: "Мотивационно писмо:",
    122: "Прикачи CV",
    123: "Изпрати",
    124: "Кандидатствай",
    125: "Въпреки че в момента нямаме отворени позиции, изпратете ни Вашето CV и ще го имаме предвид за в бъдеще.",
    126: "Кандидатури се приемат до",
    127: "Задължителни умения:",
    128: "Допълнителни умения:",
    129: "Предимства:",
    130: "Какво предлагаме:",
    131: "Процес:",
    132: "С одобрените кандидати ще се свържем в рамките на 5 работни дни, за да насрочим техническо интервю.",
    133: "",
  }

  private static englishPhrases = {
    1: "Home",
    2: "About us",
    3: "Services",
    4: "Contact us",
		5: "Work hours: Monday-Friday 08:30-17:30",
		6: "Address: Bulgaria, Ruse city, Sveta Troitza 2 square, floor 1",
		7: "Phone",
		8: "Email",
    9: "Contact us",
    10: "Have any questions? Fill the contact form and we will answer you as soon as possible or schedule 30 min online meeting in Google Meet from ",
    11: "Topic",
    12: "First name",
    13: "Last name",
    14: "Message",
    15: "Send",
    16: "John",
    17: "Doe",
    18: "example@gmail.com",
    19: "Mariyan Marinov",
    20: "CEO, Senior Software Developer",
    21: "Photo",
    22: "<p>Mariyan is Senior full-stack software developer with over 10 years of professional experience in developing and maintaining software. His backend programming experience is mostly in .NET ecosystem - using C# and Visual Basic but he also have good enough knowlage in NodeJS as alternative. He is very familiar with Entity Framework Core and Dapper as ORM solutions. Through the years he have been worked with wide variety of relational and non-relational databases like MSSQL, MySQL, PostgreSQL, Cassandra.</p> <p>For front-end development Mariyan is skilled using React, Angular and Aurelia frameworks both with JavaScript and TypeScript, jQuery, CSS, SCSS, SASS, Bootstrap, Prime React, Angular Materials.</p> <p>As it comes to Cloud, infrastructure and deployment - his strengths are in Amazon Web Services, Azure, Docker and Terraform.</p>",
    23: "Joro Paspalev",
    24: "Software Developer",
    25: "<p>Joro is full-stack software developer with 3 years professional experience in developing and maintaining software. His development stack includes C#, JavaScript, TypeScript, Entity Framework Core, Dapper, SQL, MySQL, MSSQL Server, MySQL, PostgreSQL, Angular, Bootstrap, CSS, SCSS, SASS, Angular Material, Amazon Web Services, Docker, Terraform.</p>",
    26: "Daniel Dianov",
    27: "Junior Software Developer",
    28: "<p>Daniel is full-stack software developer with 1 year professional experience.His development stack includes C#, Visual Basic, JavaScript, TypeScript, Entity Framework Core, Dapper, SQL, MySQL, MSSQL Server, MariaDB, React, Aurelia, Angular, Bootstrap, CSS, SCSS, SASS, Docker.</p>",
    29: "Our team",
    30: "here",
    31: "and we will discuss everything that you have as a question.",
    32: "Sharp IT - Home",
    33: "Sharp IT - About us",
    34: "Sharp IT - Services",
    35: "Sharp IT - Contacts",
    36: "Sharp IT - Open positions",
    37: "Sharp IT - Not found",
    38: "Open positions",
    39: "Welcome to Sharp IT, where innovation meets functionality.",
    40: "At Sharp IT, we build more than just websites – we create powerful, scalable, and user-friendly web applications that drive business growth. Our expert team of developers, designers, and strategists work collaboratively to bring your ideas to life with technology that aligns with your goals.",
    41: "Industries we serve",
    42: "Travel & Hospitality",
    43: "Healthcare & Medical",
    44: "Retail & e-Commerce",
    45: "Education & eLearning",
    46: "Manufacturing & Logistics",
    47: "Real Estate",
    48: "Our process",
    49: "Discovery & Planning",
    50: "We start by understanding your business challenges and goals, helping you define the project scope, timelines, and resources.",
    51: "Design & Prototyping",
    52: "Our design team creates wireframes, mockups, and prototypes to visualize the user experience and get your feedback before development begins.",
    53: "Development & Testing",
    54: "We bring the project to life, writing clean, scalable code and conducting thorough testing to ensure everything works as expected.",
    55: "Launch & Support",
    56: "Once your project is ready, we help you deploy it and provide ongoing support to keep things running smoothly.",
    57: "Expertise You Can Trust",
    58: "With years of experience in the software development industry, we leverage the latest technologies and best practices to deliver high-quality solutions that work.",
    59: "Client-Focused Approach",
    60: "We take the time to understand your business objectives and craft personalized solutions that drive tangible results. Your success is our success.",
    61: "Agile & Collaborative Process",
    62: "Our agile development methodology ensures that projects are delivered on time and within budget. We value collaboration, transparency, and clear communication at every stage.",
    63: "End-to-End Service",
    64: "From initial consultation to post-launch support, we provide comprehensive services to ensure your project’s success at every phase of the development lifecycle.",
    65: "Cutting-Edge Technologies",
    66: "Our team is proficient in a wide array of programming languages, frameworks, and tools, including C#, JavaScript, TypeScript, React, Angular and more.",
    67: "Why Choose Us?",
    68: "Explore our services",
    69: "Learn more",
    70: "Web Application Development",
    71: "Building dynamic, data-driven applications that support your business processes, integrate with third-party systems, and scale as you grow.",
    72: "eCommerce Solutions",
    73: "End-to-end eCommerce platform development, from product catalogs to secure payment systems and seamless customer experiences.",
    74: "Content Management Systems",
    75: "Robust, flexible CMS platforms, enabling you to manage content easily and efficiently without technical expertise.",
    76: "UX/UI Design",
    77: "Intuitive and visually appealing designs that prioritize user experience. Our designs ensure your website or application is both functional and aesthetically pleasing.",
    78: "Website Maintenance & Support",
    79: "Ongoing maintenance and support to ensure your website stays up-to-date, secure, and optimized for performance.",
    80: "Our services",
    81: "We are fast growing company located in Ruse, Bulgaria which is specialized in Web Development for various real-life needs.",
    82: "At Sharp IT, our greatest strength lies in our people.",
    83: "Our team is composed of highly skilled professionals who are passionate about leveraging technology to create impactful solutions.",
    84: "We are not just developers; we are problem solvers who thrive on challenges and are dedicated to driving success for our clients.",
    85: "We are driven by a commitment to deliver more than just products.",
    86: "Our cozy office fosters collaboration and creativity, providing a comfortable space for our talented team of developers and tech enthusiasts.",
    87: "We offer warm and friendly environment and prioritize work-life balance. Breaks for recharge are highly encouraged.",
    88: "At Sharp IT, we believe in building partnerships that empower businesses to reach their full potential.",
    89: "Our approach is rooted in transparency, collaboration, and a deep understanding of industry trends.",
    90: "Our team collaborates closely with clients to understand their needs, bringing valuable solutions that automate processes, enhance productivity, and drive continuous improvement.",
    91: "By staying ahead of the curve, we help businesses not only adapt to change but also thrive in an ever-evolving digital landscape.",
    92: "At Sharp IT, your growth is our mission, and we are dedicated to being your trusted partner every step of the way.",
    93: "Projects that we have worked on",
    94: "Our team brings a wealth of experience across a variety of industries, including:",
    95: "Finance and Audit: Crafting secure and efficient systems that ensure compliance and streamline complex financial workflows.",
    96: "Road/Pavement Management: Developing intelligent solutions for infrastructure monitoring and predictive maintenance.",
    97: "Event Management: Enhancing event coordination and planning with innovative automation tools.",
    98: "Technical expertise",
    99: "We are technically versatile and adaptable, having worked extensively on:",
    100: "Diverse Architectures: From monolithic systems to microservices architectures, we design solutions that are scalable, maintainable, and robust.",
    101: "Cloud Platforms: Leveraging the power of AWS (S3, Route53, Lambdas, Batches, Step Functions) and Azure for secure and scalable cloud solutions.",
    102: "CI/CD Excellence: Implementing well-structured deployment pipelines using GitHub Actions and Terraform, ensuring smooth and efficient delivery cycles.",
    103: "Our tech stack includes:",
    104: "Allowed file types",
    105: "Max allowed size",
    106: "Unsupported file format.",
    107: "Unsupported file size.",
    108: "File is too large.",
    109: "Files bigger than 5 MB can not be sent.",
    110: "File format not supported.",
    111: "The file format is not supported. Supported formats are PDF, DOC and DOCX.",
    112: "Sending your application ",
    113: "File not uploaded",
    114: "CV attachment is required in order to proceed.",
    115: "Success",
    116: "Application submitted successfully.",
    117: "Unexpected error occured.",
    118: "Please use the contact form to report this problem.",
    119: "GitHub profile:",
    120: "LinkedIn profile:",
    121: "Motivational letter:",
    122: "Attach CV",
    123: "Apply",
    124: "Apply here",
    125: "Although there are no available positions at the moment, feel free to share your CV, and we will keep it on file for any future openings that may arise.",
    126: "Applications are accepted until",
    127: "Required skills:",
    128: "Nice to have:",
    129: "Advantages:",
    130: "What we offer:",
    131: "Hiring process:",
    132: "Approved candidates will be contacted to schedule technical interview in 5 working days after application is submitted.",
    133: "",
  }

  public static getPhrases(language: string | null) {
    if (language === "BG") {
      return this.bulgarianPhrases;
    }

    return this.englishPhrases;
  }
}